import './BlogGrid.css';

const CATEGORY_ACCENTS = {
  'Digital Marketing': '#63ba46',
  'Web Development': '#2f9e8f',
  'AI & Technology': '#8a5cf6',
  'Social Media': '#e2673f',
  'Graphic Design': '#e2a300',
  'eCommerce': '#3f9c6d',
};
const DEFAULT_ACCENT = 'var(--green)';

function accentFor(cat) {
  return CATEGORY_ACCENTS[cat] || DEFAULT_ACCENT;
}

function readMins(post) {
  const body = (post.content && post.content.trim()) ? post.content : (post.desc || '');
  const words = body.split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.round(words / 200));
}

// Static (non-scrolling) blog card grid with a staggered reveal and rich
// hover motion — colored category pill + reading-time badge on the image,
// accent-colored "Read Article" link underneath.
export default function BlogGrid({ posts }) {
  return (
    <div className="bgd-grid reveal stagger">
      {posts.map((p) => {
        const accent = accentFor(p.cat);
        return (
          <a
            key={p.id || p.title}
            href={`#/blog/${p.id}`}
            className="bgd-card"
            style={{ '--accent': accent }}
          >
            <div className="bgd-img">
              <img src={p.img} alt={p.title} loading="lazy" />
              <span className="bgd-cat">{p.cat}</span>
              <span className="bgd-time">{readMins(p)} min</span>
            </div>
            <div className="bgd-body">
              <h3>{p.title}</h3>
              <span className="bgd-read">Read Article <span className="bgd-arrow">→</span></span>
            </div>
          </a>
        );
      })}
    </div>
  );
}
